import HeroSection from "../components/contact/hero.jsx";
import AgentCard from "../components/home/AgentCard.jsx";
import ContactForm from "../components/contact/contactForm.jsx"
import Navbar from "../components/Navbar.jsx";
import Footer from "../components/Footer.jsx";

const ContactPage = () => {
  return (
    <div>
      <Navbar />
      <HeroSection />
      <ContactForm />
      <AgentCard />
      <Footer />
    </div>
  );
};

export default ContactPage;
